
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

/*************Generator methos ******************/
export function* fillEmptyValues(currentDate , endDate,  periodType ) {

    if(periodType === 'hour') {
        let noOfDays = ((new Date(endDate) - new Date(currentDate))  /(1000*60*60*24))+1;

        for (let day = 1; day <= noOfDays; day++) {
            for (let hour = 0; hour <= 23; hour++) {
                yield [currentDate, String(hour ).padStart(2,0)];
            }
            console.log("nextDate"+ currentDate);

            let nextDate = getNextDate(new Date(currentDate) , 1);
            currentDate = nextDate;
        }
    }
}

export function* formatJsonAsGraph( dashboardGraph ) {

    for (let i = 0; i < dashboardGraph.length; i++) {
        let key = dashboardGraph[i]['key'];
        let value = { "vignet_views" : dashboardGraph[i]['vignet_views'].value, "page_views" : dashboardGraph[i]['page_views'].value, "name" :  dashboardGraph[i]['key_as_string'] };
        yield [key, value];
    }
}

export const getFormattedDate = (this_date, format, seperator ) => {

    let formattedDate = '';

    let options = { year: 'numeric', month: 'short', day: 'numeric' };

    let this_day = this_date.getDate();
    this_day = String(this_day ).padStart(2,0);
    let this_month = this_date.getMonth()+1;
    this_month = String(this_month ).padStart(2,0);
    const this_year = this_date.getFullYear();

    if(format === 'Ymd') {
        formattedDate = this_year+ seperator +this_month+ seperator +this_day;
    }
    else if(format === 'dmY') {
        formattedDate = this_day+ seperator +this_month+ seperator +this_year;
    }
    else if(format === 'mdY') {
        formattedDate = this_month+ seperator +this_day+ seperator +this_year;
    }
    else if(format === 'MdY') {
        formattedDate = this_date.toLocaleDateString("en-US", options);
    }

    return formattedDate;
}

export const getFormattedMonth = (this_month, this_year ) => {

    let formattedMonth = '';

    let options = { year: 'numeric', month: 'short' };
    var this_date = new Date(Date.UTC(this_year, this_month, 1, 0, 0, 0));
    console.log("this_date"+this_date);
    formattedMonth = this_date.toLocaleDateString("en-US", options);


    return formattedMonth;
}

export const getNextDate = (presentDate , interval) => {
    var nextDate = new Date(presentDate);
    nextDate.setDate(presentDate.getDate() +interval);
    return nextDate;
}

export const getNoOfMonthsInBetween = (fromDate, toDate ) => {

    let startDate = new Date(fromDate);
    let endDate = new Date(toDate);


    let startMonth = startDate.getMonth()+1;
    let startYear = startDate.getFullYear();
    let endMonth = endDate.getMonth()+1;
    let endYear = endDate.getFullYear();

    let diffYear = endYear - startYear;

    let noOfMonths = ((diffYear - 1)*12) + (12-startMonth)+endMonth;

    return noOfMonths;
}

export const addNewField =( jsonElement, name, periodType, keyValue) => {
    if(periodType === 'hour') {
        jsonElement.name = String(name ).padStart(2,0);
        jsonElement.hour = keyValue;
    }
    else if(periodType === 'day') {
        jsonElement.name = name;
        jsonElement.day = keyValue;
    }
    else if(periodType === 'month') {
        jsonElement.name = name;
        jsonElement.month = keyValue;
    }
    else if(periodType === 'year') {
        jsonElement.name = name;
        jsonElement.year = keyValue;
    }

    return jsonElement;
}

export const  sortByKey = (property) => {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        console.log(a[property]);
        console.log(b[property]);
        if(sortOrder === -1){
            return b[property]-a[property];
        }else{
            return a[property]-b[property];
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/graph.js